module.exports = __webpack_public_path__ + "img/score_device_fr.7858382b.png";